export default "__VITE_ASSET__09c7a5e5__"